import React, { useState, useEffect } from "react";
import "./Foydalanuvchi.css";
import { FaTimes, FaCog, FaDoorOpen, FaDoorClosed, FaBell, FaMoon, FaSun } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import CONFIG from "../config";

import Malumot from "./Malumot";
import Dasturlash from "./Dasturlash";
import Mantiq from "./Mantiq";
import Kurs from "./Kurs";
import Bank from "./Bank";
import NotificationModal from "./NotificationModal";
import PaymentModal from "./PaymentModal";
import LogicStatisticsModal from "../Taxrirlovchi/LogicStatisticsModal";

function Foydalanuvchi({ isOpen, toggleUserPanel, darkMode, toggleDarkMode, userData, kurslar, refreshData, openNotifs, darajalar }) {
  const [isLogoutHovered, setIsLogoutHovered] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showLogicStats, setShowLogicStats] = useState(false);
  const [triggerCert, setTriggerCert] = useState(0); // Use counter as trigger

  // Sync with global userData unread count (it's inside 'rank' object)
  useEffect(() => {
    if (userData && userData.rank && userData.rank.unread_notifications !== undefined) {
      setUnreadCount(userData.rank.unread_notifications);
    }
  }, [userData]);

  return (
    <>
      <div className={`foydalanuvchi-quti ${isOpen ? "open" : ""}`}>
        <div className="foydalanuvchi-yopish" onClick={toggleUserPanel}>
          <FaTimes />
        </div>
        <div className="foydalanuvchi-scroll">
          <Malumot userData={userData} darajalar={darajalar} />
          <Dasturlash userData={userData} />
          <Mantiq
            userData={userData}
            darajalar={darajalar}
            onStatsClick={() => setShowLogicStats(true)}
            triggerCert={triggerCert}
          />
          <Kurs kurslar={kurslar} darkMode={darkMode} toggleUserPanel={toggleUserPanel} />
        </div>

        <div className="foydalanuvchi-footer">
          <div className="f-util-item bell-item" onClick={() => openNotifs && openNotifs()}>
            <FaBell className="f-icon" />
            {unreadCount > 0 && <span className="notif-badge">{unreadCount}</span>}
          </div>

          <NavLink to="/sozlama" className="f-util-item settings-item">
            <FaCog className="f-icon" />
          </NavLink>

          <div className="f-util-item" onClick={toggleDarkMode}>
            {darkMode ? <FaSun className="f-icon" /> : <FaMoon className="f-icon" />}
          </div>

          <div
            className="f-util-item"
            onMouseEnter={() => setIsLogoutHovered(true)}
            onMouseLeave={() => setIsLogoutHovered(false)}
            onClick={() => {
              localStorage.removeItem("loyiha_token");
              localStorage.removeItem("loyiha_user");
              window.location.href = "/";
            }}
            style={{ cursor: "pointer" }}
          >
            {isLogoutHovered ? <FaDoorClosed className="f-icon" /> : <FaDoorOpen className="f-icon" />}
          </div>
        </div>

        <Bank
          userData={userData}
          onOpenPayment={() => setShowPaymentModal(true)}
          onOpenCert={() => setTriggerCert(prev => prev + 1)}
        />
      </div>

      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        userData={userData}
      />

      <LogicStatisticsModal
        isOpen={showLogicStats}
        onClose={() => setShowLogicStats(false)}
        userData={userData}
      />
    </>
  );
}

export default Foydalanuvchi;
